import resetIcon from 'assets/icons/reseticon.svg';
import styled from 'styled-components';

export const ResetIcon = styled.div`
  width: 1.3rem;
  height: 1.3rem;
  background-image: url(${resetIcon});
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
`;
